import { SectionTitle } from 'packages/kakapo-ui-kit/components/common/Headings';

export default function ReviewGoals() {
	return <SectionTitle>Review goals</SectionTitle>;
}
